import { adNewPhoneValid } from '@/components/registerPhoneValidPop/index.js';
export default {
    i18next: {
        ns: 'md-calculator'
    },
    methods: {
        submitAndPhoneValid(callback) {
            const session = localStorage.getItem('md-calculator__adPhoneValid');
            if (!session) {
                adNewPhoneValid
                    .showRegisterPhoneAndCompletionPage()
                    .then(isShow => {
                        if (!isShow) {
                            callback?.();
                            return;
                        }
                        localStorage.setItem(
                            'md-calculator__adPhoneValid',
                            '1'
                        );
                        adNewPhoneValid.openRegisterPhoneValidPop({
                            isFromRegister: false,
                            afterClose: () => {
                                callback?.();
                            }
                        });
                    });
                return;
            }
            callback?.();
        }
    }
};
